import api from '../callApi';

export const completeVideoRecording = (apiRequestData,videoName,videoId) => {
    const request = {
        ...apiRequestData,
        videoName,
        videoId
    };

    return api
        .post('Widget/CompleteRecordVideoAsync', request)
        .then(response => response);
};
